import React, { useEffect, useRef } from 'react'
import "../styles/Home.scss";
import Logo from "../assets/lumus.svg"
import VerifiedPsychics from "../assets/Verified_Account.svg"
import PrivateChat from "../assets/private_chat.svg"
import SecurePayments from "../assets/Secure_Payment.svg"
import DownloadIcon from "../assets/download.svg"
import img1 from "../assets/carousel-images/1.svg";
import img2 from "../assets/carousel-images/2.svg";
import img3 from "../assets/carousel-images/3.svg";
import img4 from "../assets/carousel-images/4.svg";
import img5 from "../assets/carousel-images/5.svg";

import Horo1 from "../assets/carousel-daily-horoscope/daily horoscope-image-05.svg";
import Horo2 from "../assets/carousel-daily-horoscope/daily horoscope-image-08.svg";
import Horo3 from "../assets/carousel-daily-horoscope/daily horoscope-image-10.svg";
import Horo4 from "../assets/carousel-daily-horoscope/daily-horoscope-image-01.svg";
import Horo5 from "../assets/carousel-daily-horoscope/daily-horoscope-image-03.svg";
import Horo6 from "../assets/carousel-daily-horoscope/daily-horoscope-image-04.svg";

import RatingStars from "../assets/rating-stars.svg"
import Star from "../assets/Vector.svg"

import Layout from '../components/Layout';
import BannerHeader from '../components/BannerHeader';



const Home = () => {


const generateOneLinkURL = () => {
  const oneLinkURL = "https://lumus.onelink.me/czmL/48qyvxl4";

  // Helper to get parameter from URL
  const getParamFromURL = (paramNames: string[], defaultValue: string = ''): string => {
    const urlParams = new URLSearchParams(window.location.search);
    for (const name of paramNames) {
      if (urlParams.has(name)) {
        return urlParams.get(name) || defaultValue;
      }
    }
    return defaultValue;
  };

  // Define parameters
  const mediaSource = getParamFromURL(["utm_source"], "website");
  const campaign = getParamFromURL(["utm_campaign"], "website");
  const clickid = getParamFromURL(["clickid"]);
  const af_ss_ui = getParamFromURL(["af_ss_ui"], "true");
  const af_ss_gtm_ui = getParamFromURL(["af_ss_gtm_ui"], "true");

  // Build final URL
  const finalURL = new URL(oneLinkURL);
  finalURL.searchParams.append("af_media_source", mediaSource);
  finalURL.searchParams.append("af_campaign", campaign);

  if (clickid) finalURL.searchParams.append("clickid", clickid);
  if (af_ss_ui) finalURL.searchParams.append("af_ss_ui", af_ss_ui);
  if (af_ss_gtm_ui) finalURL.searchParams.append("af_ss_gtm_ui", af_ss_gtm_ui);
return finalURL.toString();
}

const redirectToLink = () => {
  const url = generateOneLinkURL(); // get the link
  if (url) {
    window.location.href = url;
 
  }  else{
    window.location.href = "https://lumus.onelink.me/czmL/48qyvxl4"; 
  }

}

    const carouselImages = [
    img1,img2,img3,img4,img5
    
    ]
    
    const HoroscopeData = [
      { id:1,
        img : Horo1,
        name:"Charron",
        date:"11 Jun",
        rating:"5",
        description : "She doesn’t need info! She’s 100% accurate. Open your mind and let her connect in spirit. She’s a REAL ADVISOR, and her predictions are always spot on!"
      },
      { id:2,
        img : Horo2,
        name:"Mike",
        date:"26 May",
        rating:"5",
        description : "Chatting with you was a turning point for me. Your readings provided clarity on my past struggles I'm forever grateful for your impact on my jour..."
      },
      { id:3,
        img : Horo3,
        name:"Stella",
        date:"18 Apr",
        rating:"4.8",
        description : "An eye opening experience for sure!!! I can now see things from a different way. 🙏😊😊 Thank you so much for being their and listening to me and gu... "
      },
      { id:4,
        img : Horo4,
        name:"Doris",
        date:"9 Feb",
        rating:"5",
        description : "omg he’s really good. he gave me piece of mind and also I have a clear direction of the way ahead m thank you so much for your readings. "
      },
      { id:5,
        img : Horo5,
        name:"Layla",
        date:"12 Dec",
        rating:"5",
        description : "She really understood what I was going through and explained things so clearly. I felt calm after the chat, and her energy was so comforting."
      },
      { id:6,
        img : Horo6,
        name:"Hannah",
        date:"16 Aug ",
        rating:"4.2",
        description : "Her warm nature instantly put me at ease, and her intuitive understanding of my current situation left me in awe. 🙏😊 Suggesting everyone to get her g..."
      },
      
    ]


  return (
    <Layout>
   <BannerHeader title={"Lumus"} subtitle={"Trusted app for psychic reading, tarot & love advice"}/>

    <div className="find-right">
     <span>Find the right psychic for love, career or life clarity</span>
    </div>
    <div className="first-consultation">
      <span>First Consultation Free</span>
    </div>
    <div className="landing-icons-wrapper">
     <div className="landing-icon">
       <img src={VerifiedPsychics} alt="" />
       <span>Verified
       Psychics</span>
     </div>
     <div className="landing-icon">
       <img src={PrivateChat} alt="" />
       <span>Private
       Chats</span>
     </div>
     <div className="landing-icon">
       <img src={SecurePayments} alt="" />
       <span>Secure
       Payments</span>
     </div>
    </div>
    <div className="download-free-chat-btn"   onClick={() => redirectToLink()}>
       <img src={DownloadIcon} alt="" />
       <span>Download & get free chat</span>
    </div>
    <p className="connect-with">Connect with best psychic for 1-on-1 chat, call or video reading</p>
    <div className="carousel-wrapper">
  <div className="carousel-slides">
    {carouselImages.map((src, index) => (
      <div className="slide" key={index}>
        <img src={src} alt={`slide-${index}`} />
      </div>
    ))}
  </div>

</div>

<div className="testimonial-wrapper">
       <span className="testimonial-number">4.9</span>
       <div className="testimonial-stars">
        <img src={RatingStars} alt="" />
       </div>
       <span className="testimonial-totalReviews">31,214 reviews</span>
  </div>

    <div className="carousel-wrapper horoscope">
      <div className="carousel-slides-horoscope">
        {HoroscopeData.map((item , index) =>(
        <div className="slide-horoscope" key={index}>
         <div className="slide-header">
             <div className="dp-wrapper">
              <div className="dp">
              <img src={item.img} alt="dp" />
              <div>
             
              </div>
            
              </div>
              <div className="dp-value">
              <span className="dp-name">{item.name}</span>
              <span className="dp-date">{item.date}</span>
              </div>
           

             </div>
             <div className="rating">
                 <img src={Star} alt="" />
                 <span>{item.rating}</span>
             </div>

         </div>
         <div className="slide-description">
            <p>{item.description}</p>
         </div>
         </div>
))}
      </div>
    </div>

    <p className="bottom-text">Start your spiritual journey today!</p>

    
   
    
    </Layout>
  )
}

export default Home